export default "__VITE_ASSET__DyRxmgYT__"